export default {"src":"/_next/static/media/redact-personal-content-icon.f12a4b3f.svg","height":40,"width":39,"blurWidth":0,"blurHeight":0};